var swiper = new Swiper(".service-slider", {
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
  },
  breakpoints: {
    990: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    0: {
      slidesPerView: 1.8,
      spaceBetween: 20,
    },
  },
});
